/**
 * Every rule and shaded cell of the UDYOG form, one entry per page, in PDF points
 * ([x, y down from the top, w, h]). Lifted from the source PDF's own path
 * operators — a Word export draws each table edge as thin filled rectangles —
 * with collinear pieces merged. Fill `g` is the #F2F2F2 row shading, `d` the dark
 * green band behind the part titles. Generated; re-extract rather than hand-edit.
 */
export const PAGE_GEOMETRY = [
    {
        rules: [
            [102.74, 93.38, 458.11, 2.16],
            [263.45, 128.3, 68.42, 0.24],
            [36, 157.34, 523.42, 0.48],
            [36.48, 176.54, 522.45, 0.48],
            [36.48, 199.46, 396.79, 0.48],
            [207.29, 222.26, 225.98, 0.48],
            [36.48, 245.18, 396.79, 0.48],
            [36.48, 268.01, 396.79, 0.48],
            [36.48, 290.93, 396.79, 0.48],
            [36.48, 313.73, 522.45, 0.48],
            [36.48, 336.53, 522.46, 0.48],
            [36, 404.09, 523.42, 0.48],
            [36, 440.95, 523.42, 0.72],
            [207.41, 480.43, 351.29, 0.48],
            [36.72, 518.35, 521.98, 0.48],
            [36.72, 540.67, 521.98, 0.48],
            [36.72, 562.87, 521.98, 0.48],
            [36.72, 585.07, 521.98, 0.48],
            [36.72, 623.14, 521.98, 0.48],
            [36.72, 645.46, 521.98, 0.48],
            [67.82, 683.38, 490.88, 0.48],
            [36.72, 705.7, 521.98, 0.48],
            [36.72, 743.62, 521.98, 0.48],
            [36.72, 765.94, 521.98, 0.48],
            [36, 788.14, 523.42, 0.72],
            [36, 157.34, 0.48, 246.75],
            [36, 440.95, 0.72, 347.19],
            [67.34, 441.67, 0.48, 346.47],
            [206.81, 177.02, 0.48, 227.07],
            [206.93, 441.67, 0.48, 346.47],
            [237.65, 177.02, 0.48, 22.44],
            [237.65, 245.66, 0.48, 22.35],
            [265.61, 177.02, 0.48, 22.44],
            [265.61, 245.66, 0.48, 22.35],
            [284.21, 441.67, 0.48, 76.68],
            [293.45, 177.02, 0.48, 22.44],
            [293.45, 245.66, 0.48, 22.35],
            [321.43, 177.02, 0.48, 22.44],
            [321.43, 245.66, 0.48, 22.35],
            [349.39, 177.02, 0.48, 22.44],
            [349.39, 245.66, 0.48, 22.35],
            [377.35, 177.02, 0.48, 22.44],
            [377.35, 245.66, 0.48, 22.35],
            [405.31, 177.02, 0.48, 22.44],
            [405.31, 245.66, 0.48, 22.35],
            [433.27, 157.82, 0.48, 155.91],
            [558.7, 440.95, 0.72, 347.19],
            [558.94, 157.34, 0.48, 246.75],
        ],
        fills: [
            [36.48, 157.82, 396.79, 18.72, 'd'],
            [433.75, 157.82, 125.18, 18.72, 'd'],
            [207.29, 177.14, 30.36, 22.32, 'g'],
            [266.09, 177.14, 27.36, 22.32, 'g'],
            [321.91, 177.14, 27.48, 22.32, 'g'],
            [377.83, 177.14, 27.48, 22.32, 'g'],
            [207.29, 245.67, 30.36, 22.34, 'g'],
            [266.09, 245.67, 27.36, 22.34, 'g'],
            [321.91, 245.67, 27.48, 22.34, 'g'],
            [377.83, 245.67, 27.48, 22.34, 'g'],
            [34.56, 417.53, 526.3, 17.4, 'd'],
            [36.72, 518.83, 30.62, 21.84, 'g'],
            [67.82, 518.83, 139.1, 21.84, 'g'],
            [207.41, 518.83, 351.29, 21.84, 'g'],
            [36.36, 537.67, 31.22, 3, 'g'],
            [67.58, 537.67, 139.58, 3, 'g'],
            [207.17, 537.67, 351.89, 3, 'g'],
            [36.72, 563.35, 30.62, 21.72, 'g'],
            [67.82, 563.35, 139.1, 21.72, 'g'],
            [207.41, 563.35, 351.29, 21.72, 'g'],
            [36.36, 582.07, 31.22, 3, 'g'],
            [67.58, 582.07, 139.58, 3, 'g'],
            [207.17, 582.07, 351.89, 3, 'g'],
            [36.72, 623.62, 30.62, 21.84, 'g'],
            [67.82, 623.62, 139.1, 21.84, 'g'],
            [207.41, 623.62, 351.29, 21.84, 'g'],
            [36.36, 642.46, 31.22, 3, 'g'],
            [67.58, 642.46, 139.58, 3, 'g'],
            [207.17, 642.46, 351.89, 3, 'g'],
            [36.72, 706.18, 30.62, 37.44, 'g'],
            [67.82, 706.18, 139.1, 37.44, 'g'],
            [207.41, 706.18, 351.29, 37.44, 'g'],
            [36.36, 740.62, 31.22, 3, 'g'],
            [67.58, 740.62, 139.58, 3, 'g'],
            [207.17, 740.62, 351.89, 3, 'g'],
            [36.72, 766.42, 30.62, 21.72, 'g'],
            [67.82, 766.42, 139.1, 21.72, 'g'],
            [207.41, 766.42, 351.29, 21.72, 'g'],
            [36.36, 785.14, 31.22, 3, 'g'],
            [67.58, 785.14, 139.58, 3, 'g'],
            [207.17, 785.14, 351.89, 3, 'g'],
        ],
    },
    {
        rules: [
            [36, 27.72, 523.42, 0.72],
            [36.72, 97.46, 521.98, 0.48],
            [36.72, 217.94, 521.98, 0.48],
            [207.41, 240.14, 351.29, 0.48],
            [36.72, 334.61, 521.98, 0.48],
            [36, 433.85, 523.42, 0.72],
            [36, 463.39, 523.42, 0.48],
            [36, 497.35, 523.42, 0.48],
            [36, 565.75, 523.42, 0.48],
            [36, 595.03, 523.42, 0.48],
            [36, 629.02, 523.42, 0.48],
            [36, 696.58, 523.42, 0.48],
            [36, 27.72, 0.72, 406.13],
            [36, 463.87, 0.48, 101.88],
            [36, 595.52, 0.48, 101.06],
            [67.34, 28.44, 0.48, 405.41],
            [119.66, 463.87, 0.48, 101.88],
            [119.66, 595.52, 0.48, 101.06],
            [206.93, 28.44, 0.48, 405.41],
            [219.77, 463.87, 0.48, 101.88],
            [219.77, 595.52, 0.48, 101.06],
            [297.41, 463.87, 0.48, 101.88],
            [297.41, 595.52, 0.48, 101.06],
            [386.35, 463.87, 0.48, 101.88],
            [386.35, 595.52, 0.48, 101.06],
            [470.02, 463.87, 0.48, 101.88],
            [470.02, 595.52, 0.48, 101.06],
            [558.7, 27.72, 0.72, 406.13],
            [558.94, 463.87, 0.48, 101.88],
            [558.94, 595.52, 0.48, 101.06],
        ],
        fills: [
            [36.72, 97.94, 30.62, 120, 'g'],
            [67.82, 97.94, 139.1, 120, 'g'],
            [207.41, 97.94, 351.29, 120, 'g'],
            [36.36, 214.94, 31.22, 3, 'g'],
            [67.58, 214.94, 139.58, 3, 'g'],
            [207.17, 214.94, 351.89, 3, 'g'],
            [36.72, 335.09, 30.62, 98.76, 'g'],
            [67.82, 335.09, 139.1, 98.76, 'g'],
            [207.41, 335.09, 351.29, 98.76, 'g'],
            [36.36, 430.85, 31.22, 3, 'g'],
            [67.58, 430.85, 139.58, 3, 'g'],
            [207.17, 430.85, 351.89, 3, 'g'],
            [36.48, 463.87, 83.18, 33.48, 'g'],
            [120.14, 463.87, 99.62, 33.48, 'g'],
            [220.25, 463.87, 77.16, 33.48, 'g'],
            [297.89, 463.87, 88.46, 33.48, 'g'],
            [386.83, 463.87, 83.18, 33.48, 'g'],
            [470.5, 463.87, 88.44, 33.48, 'g'],
            [36.48, 595.52, 83.18, 33.5, 'g'],
            [120.14, 595.52, 99.62, 33.5, 'g'],
            [220.25, 595.52, 77.16, 33.5, 'g'],
            [297.89, 595.52, 88.46, 33.5, 'g'],
            [386.83, 595.52, 83.18, 33.5, 'g'],
            [470.5, 595.52, 88.44, 33.5, 'g'],
        ],
    },
    {
        rules: [
            [36, 81.36, 523.42, 0.72],
            [36.72, 380.93, 521.98, 0.48],
            [36.72, 403.25, 521.98, 0.48],
            [36.72, 441.19, 521.98, 0.48],
            [36.72, 506.71, 521.98, 0.48],
            [36.72, 570.07, 521.98, 0.48],
            [36.72, 623.86, 521.98, 0.48],
            [36.72, 661.9, 521.98, 0.48],
            [36.72, 699.82, 521.97, 0.48],
            [202.49, 722.14, 356.2, 0.48],
            [36.72, 744.34, 521.97, 0.48],
            [202.49, 766.66, 356.2, 0.48],
            [36, 788.86, 523.42, 0.72],
            [36, 81.36, 0.72, 707.5],
            [67.34, 82.08, 0.48, 706.78],
            [202.01, 82.08, 0.48, 706.78],
            [313.15, 700.3, 0.48, 88.56],
            [432.91, 700.3, 0.48, 88.56],
            [558.7, 81.36, 0.72, 707.5],
        ],
        fills: [
            [34.56, 58.08, 526.3, 17.4, 'd'],
            [36.72, 381.41, 30.62, 21.84, 'g'],
            [67.82, 381.41, 134.18, 21.84, 'g'],
            [202.61, 381.41, 356.09, 21.84, 'g'],
            [202.49, 381.41, 356.21, 3, 'g'],
            [36.36, 400.25, 31.22, 3, 'g'],
            [67.58, 400.25, 134.66, 3, 'g'],
            [202.25, 400.25, 356.81, 3, 'g'],
            [36.72, 441.67, 30.62, 65.04, 'g'],
            [67.82, 441.67, 134.18, 65.04, 'g'],
            [202.61, 441.67, 356.09, 65.04, 'g'],
            [202.49, 441.67, 356.21, 3, 'g'],
            [36.36, 503.71, 31.22, 3, 'g'],
            [67.58, 503.71, 134.66, 3, 'g'],
            [202.25, 503.71, 356.81, 3, 'g'],
            [36.72, 570.56, 30.62, 53.3, 'g'],
            [67.82, 570.56, 134.18, 53.3, 'g'],
            [202.61, 570.56, 356.09, 53.3, 'g'],
            [202.49, 570.55, 356.21, 3, 'g'],
            [36.36, 620.86, 31.22, 3, 'g'],
            [67.58, 620.86, 134.66, 3, 'g'],
            [202.25, 620.86, 356.81, 3, 'g'],
            [36.72, 662.38, 30.62, 37.44, 'g'],
            [67.82, 662.38, 134.18, 37.44, 'g'],
            [202.61, 662.38, 356.09, 37.44, 'g'],
            [202.49, 662.38, 356.21, 3, 'g'],
            [36.36, 696.82, 31.22, 3, 'g'],
            [67.58, 696.82, 134.66, 3, 'g'],
            [202.25, 696.82, 356.81, 3, 'g'],
            [202.61, 700.3, 110.54, 21.84, 'g'],
            [313.63, 703.3, 119.28, 15.84, 'g'],
            [433.39, 703.3, 125.3, 15.84, 'g'],
            [202.49, 700.3, 110.66, 3, 'g'],
            [313.63, 700.3, 119.28, 3, 'g'],
            [433.39, 700.3, 125.3, 3, 'g'],
            [202.25, 719.14, 111.14, 3, 'g'],
            [313.39, 719.14, 119.76, 3, 'g'],
            [433.15, 719.14, 125.78, 3, 'g'],
            [36.72, 744.82, 30.62, 44.04, 'g'],
            [67.82, 744.82, 134.18, 44.04, 'g'],
            [202.61, 744.82, 110.54, 21.84, 'g'],
            [313.63, 747.82, 119.28, 15.84, 'g'],
            [433.39, 747.82, 125.3, 15.84, 'g'],
            [202.49, 744.82, 110.66, 3, 'g'],
            [313.63, 744.82, 119.28, 3, 'g'],
            [433.39, 744.82, 125.3, 3, 'g'],
            [202.25, 763.66, 111.14, 3, 'g'],
            [313.39, 763.66, 119.76, 3, 'g'],
            [433.15, 763.66, 125.78, 3, 'g'],
            [36.36, 785.86, 31.22, 3, 'g'],
            [67.58, 785.86, 134.66, 3, 'g'],
        ],
    },
    {
        rules: [
            [36, 27.72, 523.42, 0.72],
            [36.72, 125.06, 521.98, 0.48],
            [36.72, 178.82, 521.98, 0.48],
            [36, 318.65, 523.42, 0.72],
            [36, 355.73, 523.42, 0.72],
            [36.72, 378.17, 521.98, 0.48],
            [36.72, 431.93, 521.98, 0.48],
            [36.72, 454.15, 521.98, 0.48],
            [36.72, 507.91, 521.98, 0.48],
            [36.72, 579.79, 521.97, 0.48],
            [202.49, 601.99, 356.2, 0.48],
            [36.72, 624.34, 521.97, 0.48],
            [202.49, 646.54, 356.2, 0.48],
            [36.72, 668.86, 521.97, 0.48],
            [36, 754.54, 523.42, 0.72],
            [36, 27.72, 0.72, 290.93],
            [36, 355.73, 0.72, 398.81],
            [67.34, 28.44, 0.48, 290.21],
            [67.34, 356.45, 0.48, 398.09],
            [202.01, 28.44, 0.48, 290.21],
            [202.01, 356.45, 0.48, 398.09],
            [306.29, 580.27, 0.48, 88.59],
            [429.43, 580.27, 0.48, 88.59],
            [558.7, 27.72, 0.72, 290.93],
            [558.7, 355.73, 0.72, 398.81],
        ],
        fills: [
            [36.72, 125.54, 30.62, 53.28, 'g'],
            [67.82, 125.54, 134.18, 53.28, 'g'],
            [202.61, 125.54, 356.09, 53.28, 'g'],
            [202.49, 125.54, 356.21, 3, 'g'],
            [36.36, 175.82, 31.22, 3, 'g'],
            [67.58, 175.82, 134.66, 3, 'g'],
            [202.25, 175.82, 356.81, 3, 'g'],
            [34.56, 332.33, 526.3, 17.4, 'd'],
            [36.72, 378.65, 30.62, 53.28, 'g'],
            [67.82, 378.65, 134.18, 53.28, 'g'],
            [202.61, 378.65, 356.09, 53.28, 'g'],
            [202.49, 378.65, 356.21, 3, 'g'],
            [36.36, 428.93, 31.22, 3, 'g'],
            [67.58, 428.93, 134.66, 3, 'g'],
            [202.25, 428.93, 356.81, 3, 'g'],
            [36.72, 454.75, 30.62, 53.16, 'g'],
            [67.82, 454.75, 134.18, 53.16, 'g'],
            [202.61, 454.75, 356.09, 53.16, 'g'],
            [36.72, 454.63, 30.62, 3, 'g'],
            [67.82, 454.63, 134.18, 3, 'g'],
            [202.49, 454.63, 356.21, 3, 'g'],
            [36.36, 504.91, 31.22, 3, 'g'],
            [67.58, 504.91, 134.66, 3, 'g'],
            [202.25, 504.91, 356.81, 3, 'g'],
            [36.72, 580.28, 30.62, 44.06, 'g'],
            [67.82, 580.28, 134.18, 44.06, 'g'],
            [202.61, 580.27, 103.68, 21.72, 'g'],
            [306.77, 583.27, 122.66, 15.72, 'g'],
            [429.91, 583.27, 128.78, 15.72, 'g'],
            [202.49, 580.27, 103.8, 3, 'g'],
            [306.77, 580.27, 122.66, 3, 'g'],
            [429.91, 580.27, 128.78, 3, 'g'],
            [202.25, 598.99, 104.28, 3, 'g'],
            [306.53, 598.99, 123.02, 3, 'g'],
            [429.67, 598.99, 129.26, 3, 'g'],
            [36.36, 621.34, 31.22, 3, 'g'],
            [67.58, 621.34, 134.66, 3, 'g'],
            [202.61, 624.82, 103.68, 21.72, 'g'],
            [306.77, 627.82, 122.66, 15.72, 'g'],
            [429.91, 627.82, 128.78, 15.72, 'g'],
            [202.49, 624.82, 103.8, 3, 'g'],
            [306.77, 624.82, 122.66, 3, 'g'],
            [429.91, 624.82, 128.78, 3, 'g'],
            [202.25, 643.54, 104.28, 3, 'g'],
            [306.53, 643.54, 123.02, 3, 'g'],
            [429.67, 643.54, 129.26, 3, 'g'],
            [36.72, 669.34, 30.62, 85.2, 'g'],
            [67.82, 669.34, 134.18, 85.2, 'g'],
            [202.61, 669.34, 356.09, 85.2, 'g'],
            [202.49, 669.34, 103.8, 3, 'g'],
            [36.36, 751.54, 31.22, 3, 'g'],
            [67.58, 751.54, 134.66, 3, 'g'],
            [202.25, 751.54, 356.81, 3, 'g'],
        ],
    },
    {
        rules: [
            [36, 27.72, 523.42, 0.72],
            [36.72, 116.06, 521.98, 0.48],
            [36.72, 153.98, 521.98, 0.48],
            [36.72, 205.58, 521.98, 0.48],
            [36.72, 227.9, 521.98, 0.48],
            [36.72, 367.73, 521.98, 0.48],
            [36.72, 502.99, 521.98, 0.48],
            [36.72, 556.75, 521.98, 0.48],
            [36, 759.22, 523.42, 0.72],
            [36, 27.72, 0.72, 731.5],
            [67.34, 28.44, 0.48, 730.78],
            [202.01, 28.44, 0.48, 730.78],
            [558.7, 27.72, 0.72, 731.5],
        ],
        fills: [
            [36.72, 116.54, 30.62, 37.44, 'g'],
            [67.82, 116.54, 134.18, 37.44, 'g'],
            [202.61, 116.54, 356.09, 37.44, 'g'],
            [202.49, 116.54, 356.21, 3, 'g'],
            [36.36, 150.98, 31.22, 3, 'g'],
            [67.58, 150.98, 134.66, 3, 'g'],
            [202.25, 150.98, 356.81, 3, 'g'],
            [36.72, 206.18, 30.62, 21.72, 'g'],
            [67.82, 206.18, 134.18, 21.72, 'g'],
            [202.61, 206.18, 356.09, 21.72, 'g'],
            [36.72, 206.06, 30.62, 3, 'g'],
            [67.82, 206.06, 134.18, 3, 'g'],
            [202.49, 206.06, 356.21, 3, 'g'],
            [36.36, 224.9, 31.22, 3, 'g'],
            [67.58, 224.9, 134.66, 3, 'g'],
            [202.25, 224.9, 356.81, 3, 'g'],
            [36.72, 368.21, 30.62, 134.78, 'g'],
            [67.82, 368.21, 134.18, 134.78, 'g'],
            [202.61, 368.21, 356.09, 134.78, 'g'],
            [202.49, 368.21, 356.21, 3, 'g'],
            [36.36, 499.99, 31.22, 3, 'g'],
            [67.58, 499.99, 134.66, 3, 'g'],
            [202.25, 499.99, 356.81, 3, 'g'],
            [36.72, 557.24, 30.62, 201.86, 'g'],
            [67.82, 557.24, 134.18, 201.86, 'g'],
            [202.61, 557.24, 356.09, 201.86, 'g'],
            [202.49, 557.23, 356.21, 3, 'g'],
            [36.36, 756.22, 31.22, 3, 'g'],
            [67.58, 756.22, 134.66, 3, 'g'],
            [202.25, 756.22, 356.81, 3, 'g'],
        ],
    },
    {
        rules: [
            [36, 102.5, 523.42, 0.48],
            [36, 119.78, 523.42, 0.48],
            [36, 137.06, 523.42, 0.48],
            [36, 154.34, 523.42, 0.48],
            [36, 171.62, 523.42, 0.48],
            [36, 200.78, 523.42, 0.48],
            [36, 218.06, 523.42, 0.48],
            [36, 235.34, 523.42, 0.48],
            [36, 252.5, 523.42, 0.48],
            [36, 269.81, 523.42, 0.48],
            [36, 287.09, 523.42, 0.48],
            [36, 304.37, 523.42, 0.48],
            [36, 321.53, 523.42, 0.48],
            [36, 338.81, 523.42, 0.48],
            [36, 356.09, 523.42, 0.48],
            [36, 373.37, 523.42, 0.48],
            [36, 390.53, 523.42, 0.48],
            [36, 407.81, 523.42, 0.48],
            [36, 425.09, 523.42, 0.48],
            [36, 442.39, 523.42, 0.48],
            [36, 102.98, 0.48, 68.64],
            [36, 201.26, 0.48, 241.13],
            [83.78, 201.26, 0.48, 223.83],
            [234.05, 201.26, 0.48, 241.13],
            [307.97, 102.98, 0.48, 68.64],
            [362.11, 201.26, 0.48, 241.13],
            [470.86, 201.26, 0.48, 241.13],
            [558.94, 102.98, 0.48, 68.64],
            [558.94, 201.26, 0.48, 241.13],
        ],
        fills: [
            [34.56, 56.52, 526.3, 17.4, 'd'],
            [36.48, 120.26, 271.37, 16.8, 'g'],
            [308.45, 120.26, 250.49, 16.8, 'g'],
            [36.48, 154.82, 271.37, 16.68, 'g'],
            [308.45, 154.82, 250.49, 16.68, 'g'],
            [36.48, 218.54, 47.3, 16.8, 'g'],
            [84.26, 218.54, 149.78, 16.8, 'g'],
            [234.53, 218.54, 127.58, 16.8, 'g'],
            [362.59, 218.54, 108.26, 16.8, 'g'],
            [471.34, 218.54, 87.6, 16.8, 'g'],
            [36.48, 253.11, 47.3, 16.7, 'g'],
            [84.26, 253.11, 149.78, 16.7, 'g'],
            [234.53, 253.11, 127.58, 16.7, 'g'],
            [362.59, 253.11, 108.26, 16.7, 'g'],
            [471.34, 253.11, 87.6, 16.7, 'g'],
            [36.48, 287.57, 47.3, 16.8, 'g'],
            [84.26, 287.57, 149.78, 16.8, 'g'],
            [234.53, 287.57, 127.58, 16.8, 'g'],
            [362.59, 287.57, 108.26, 16.8, 'g'],
            [471.34, 287.57, 87.6, 16.8, 'g'],
            [36.48, 322.13, 47.3, 16.68, 'g'],
            [84.26, 322.13, 149.78, 16.68, 'g'],
            [234.53, 322.13, 127.58, 16.68, 'g'],
            [362.59, 322.13, 108.26, 16.68, 'g'],
            [471.34, 322.13, 87.6, 16.68, 'g'],
            [36.48, 356.57, 47.3, 16.8, 'g'],
            [84.26, 356.57, 149.78, 16.8, 'g'],
            [234.53, 356.57, 127.58, 16.8, 'g'],
            [362.59, 356.57, 108.26, 16.8, 'g'],
            [471.34, 356.57, 87.6, 16.8, 'g'],
            [36.48, 391.13, 47.3, 16.68, 'g'],
            [84.26, 391.13, 149.78, 16.68, 'g'],
            [234.53, 391.13, 127.58, 16.68, 'g'],
            [362.59, 391.13, 108.26, 16.68, 'g'],
            [471.34, 391.13, 87.6, 16.68, 'g'],
            [36.48, 425.57, 197.57, 16.82, 'g'],
            [234.53, 425.57, 127.58, 16.82, 'g'],
            [362.59, 425.57, 108.26, 16.82, 'g'],
            [471.34, 425.57, 87.6, 16.82, 'g'],
        ],
    },
    {
        rules: [
            [36, 79.8, 523.42, 0.72],
            [36.72, 102.26, 521.97, 0.48],
            [36.72, 124.58, 521.97, 0.48],
            [36, 146.78, 523.42, 0.72],
            [36, 79.8, 0.72, 66.98],
            [78.02, 80.52, 0.48, 66.26],
            [318.43, 80.52, 0.48, 66.26],
            [558.7, 79.8, 0.72, 66.98],
        ],
        fills: [
            [34.56, 56.4, 526.3, 17.4, 'd'],
        ],
    },
];
